export default "__VITE_ASSET__097ec301__"